import { render } from "./HeaderFooterLayout.vue?vue&type=template&id=6ec5bf9a"
import script from "./HeaderFooterLayout.vue?vue&type=script&lang=js"
export * from "./HeaderFooterLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__